import React from "react";
import "./Socials.css";

const Socials = () => {
  return (
    <div className="socials-page">
      <div className="socials-container">
        <div className="socials-glass">
          <h1>Connect With Us</h1>
          <p>
            The Party Parlour isn't just about events—it's a world of magic, color, and celebration.
            Explore all our socials in one place to see how we turn every moment into an unforgettable experience.
          </p>
          <button
            onClick={() => window.open("https://linktr.ee/thepartyparlour", "_blank")}
          >
            Visit Our Linktree
          </button>
        </div>
      </div>
    </div>
  );
};

export default Socials;
